import { Button, ButtonProps, forwardRef, useBreakpointValue } from "@chakra-ui/react";
import React, { MouseEvent, useRef } from "react";
import { clearSelection } from "../utils";

interface APButtonProps extends ButtonProps {
  flexFill?: boolean
}

const APButton = forwardRef<APButtonProps, 'button'>((
  {
    children,
    flexFill = false,
    variant = "raised",
    size = "lg",
    colorScheme = "primary",
    onClick,
    ...others
  }, ref) => {
  const buttonRef = useRef<HTMLButtonElement>(null!);
  const buttonSize = useBreakpointValue(['md', size])
  const onClickHandler = (event: MouseEvent<HTMLButtonElement>) => {
    let selection;

    if (window.getSelection && (selection = window.getSelection())) {
      if (selection && selection.rangeCount > 0) {
        const range = selection.getRangeAt(0);
        if (
          !range.commonAncestorContainer.isSameNode(buttonRef!.current) &&
          !buttonRef.current.contains(range.commonAncestorContainer)
        ) {
          clearSelection();
        }
      }
    }
    if (onClick) {onClick(event);}
  }

  return (
    <Button as={"button"} ref={buttonRef}
            fontSize={["md", "lg"]}
            width={flexFill ? "100%" : "auto"}
            variant={variant}
            size={buttonSize}
            colorScheme={colorScheme}
            onClick={onClickHandler}
            {...
              others
            }>
      {children}
    </Button>
  );
});

export default APButton;
